import React, {memo} from "react";
import {getDate} from "../../helper/dateUtils";
import {convertStrToArr} from "../../helper/general";
import loading from "../../assets/images/drawing-result/loading.gif";
import Random from "./Random";
import _ from "lodash";

const RenderResult = memo(({num}) => {
    const isNumber = !_.isNaN(parseInt(num));

    if (isNumber) {
        return <span className="runLoto">{num}</span>;
    } else if (num === "?") {
        return <Random/>;
    } else {
        return <img src={loading} alt="loading" height={40}/>;
    }
});

const DrawingResult = ({drawingResult}) => {
    const {drawLabel, drawAt, results} = drawingResult;

    return <div>
        <div>
            <div>
                <h2 className="heading">កំពុងចេញលទ្ធផលឆ្នោតម៉ោង {drawLabel}</h2>
                <h3 className="heading">សំរាប់ថ្ងៃ {getDate(drawAt)}</h3>
                <div>
                    <div className="table-responsive"/>
                </div>
            </div>
        </div>

        <div id="result" align="center">
            <table className="live_bg">
                <tbody>
                <tr height={21}>
                    <td/>
                </tr>
                {
                    results.map((result, i) => {
                        const {number, postCode} = result;
                        const getResult = convertStrToArr(number);
                        return <tr key={i} height={i === 1 ? 57 : 56} valign="middle">
                            <td style={{width: 117}}>
                                <img alt="" src={require(`../../assets/images/drawing-result/result_${postCode}.png`)}
                                     height={40}/>
                            </td>
                            {
                                getResult.map((num, index) => {
                                    const width = [0, 3].includes(index)
                                    return <td key={index}
                                               style={width ? {width: 59} : {width: 58}}
                                               className="boxnum">
                                        <RenderResult num={num}/>
                                    </td>
                                })
                            }
                            <td/>
                        </tr>
                    })
                }
                <tr valign="middle">
                    <td/>
                    <td/>
                </tr>
                </tbody>
            </table>
        </div>

    </div>
}

export default memo(DrawingResult);